export const GET_ALL_SCHEMES_REQUEST = "GET_ALL_SCHEMES_REQUEST";
export const GET_ALL_SCHEMES_SUCCESS = "GET_ALL_SCHEMES_SUCCESS";
export const GET_ALL_SCHEMES_FAILURE = "GET_ALL_SCHEMES_FAILURE";
